import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebCorrectOrder({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [websiteChoices, setWebsiteChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);

    const [initialChoicesCount, setInitialChoicesCount] = useState(Array.isArray(questionData.answer.value)
        ? questionData.answer.value.length
        : Object.keys(questionData.answer.value).length);

    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setWebsiteChoices({});
        setSelectedChoice(null);
        setSelectedKeyPrevious(null);
        setInitialChoicesCount(Array.isArray(questionData.answer.value)
            ? questionData.answer.value.length
            : Object.keys(questionData.answer.value).length);
        setAvailableChoices(makeArrayRandom(data.choices));
    }, [question,
        questionData.answer,
        data.choices,
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (websiteChoices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === websiteChoices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== websiteChoices[index]?.value)) {
            let currentWebsiteChoices = {...websiteChoices};
            const previousChoice = websiteChoices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentWebsiteChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentWebsiteChoices = {
                ...currentWebsiteChoices,
                [index]: {
                    header: selectedChoice.header,
                    value: selectedChoice.value,
                },
            }
            setWebsiteChoices(currentWebsiteChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {
            } else {
                const updatedAnswer = Object.values(currentWebsiteChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
        }
    };

    const handleRemoveChoice = (index) => {
        const removedChoice = websiteChoices[index];

        if (removedChoice) {
            setWebsiteChoices((prevChoices) => {
                const newChoices = { ...prevChoices };
                delete newChoices[index];

                if (
                    typeof questionData.answer.value === "object" &&
                    !Array.isArray(questionData.answer.value)
                ) {
                    const answerKeys = Object.keys(
                        questionData.answer.value
                    );

                    const formattedAnswer = answerKeys.reduce(
                        (acc, key, keyIndex) => {
                            acc[key] = newChoices[keyIndex]?.value || null;
                            return acc;
                        },
                        {}
                    );

                    // set to false so that next button will be disabled
                    const canProceed = false;
                    onAnswer({
                        canProceed,
                        answer: formattedAnswer,
                    });
                } else {
                    const updatedAnswer = Object.values(newChoices).map(
                        (choice) => choice.value
                    );
                    // set to false so that next button will be disabled
                    const canProceed = updatedAnswer.length > 0;
                    onAnswer({
                        canProceed,
                        answer: updatedAnswer,
                    });
                }

                return newChoices;
            });

            setAvailableChoices((prevChoices) => [
                ...prevChoices,
                {
                    header: removedChoice.header,
                    value: removedChoice.value,
                },
            ]);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "854px",
                height: "500px",
            }}
        >
            <Box sx={{
                position: "relative",
                textAlign: "center"
            }}>
                <Box
                    sx={{
                        width: "854px",
                        height: "62px",
                        marginBottom: "10px",
                        border: "1px dashed lightgrey",
                        textAlign: "center",
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            paddingTop: "5px",
                            position: "absolute",
                            top: "6px",
                            left: "0",
                            textAlign: "center",
                        }}
                    >
                        {availableChoices.map((choice, index) => (
                            <Box className={"selection-button-border " + (selectedChoice?.value === choice.value ? "choice-button-selected" : "")}
                                key={index}
                                onClick={() => handleChoiceClick(choice)}
                                disabled={selectedChoice === choice}
                                // fullWidth
                                // disableRipple
                                sx={{
                                    borderBottom:
                                        "10px solid rgb(52, 148, 186)",
                                    marginRight: "5px",
                                    marginBottom: "5px",
                                    height: "42px",
                                    width: "122px",
                                    backgroundColor:
                                        "rgb(170, 214, 231) !important",
                                    lineHeight: "1em",
                                    display: "inline-block",
                                    color: "black !important",
                                    fontWeight:
                                        typeof questionData.answer.value ===
                                            "object" &&
                                        !Array.isArray(
                                            questionData.answer.value
                                        )
                                            ? "normal"
                                            : "bold",
                                    fontSize:
                                        typeof questionData.answer.value ===
                                            "object" &&
                                        !Array.isArray(
                                            questionData.answer.value
                                        )
                                            ? "12px"
                                            : "22px",
                                }}
                            >
                                <div style={{ fontWeight: "bold" }}>
                                    {choice.header}
                                </div>
                                <div>{choice.value}</div>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: "854px",
                        height: "427px",
                        aspectRatio: "550 / 420",
                        margin: "0 auto",
                        padding: "20px",
                        backgroundImage: `url(${imagesResources}${data.image})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                    }}
                >
                    {[...Array(initialChoicesCount)].map((_, index) => (
                        <Box
                            className={"selection-button-border " + (selectedChoice ? "choice-button-selected" : "")} 
                            key={index}
                            sx={{
                                position: "absolute",
                                top:
                                    typeof questionData.answer.value === "object" &&
                                    !Array.isArray(questionData.answer.value)
                                        ? "64.5%"
                                        : "20.5%",
                                left:
                                    typeof questionData.answer.value === "object" &&
                                    !Array.isArray(questionData.answer.value)
                                        ? `${7 + index * 14.3}%`
                                        : `${22 + index * 15}%`,
                                transform: "translate(-50%, -50%)",
                                width: "122px",
                                maxWidth: "122px",
                                height: "42px",
                                maxHeight: "43px",
                                aspectRatio: "170 / 10",
                                display: "flex",
                                borderTop: websiteChoices[index]
                                    ? "none"
                                    : "10px solid rgb(91, 105, 106)",
                                backgroundColor: websiteChoices[index]
                                    ? "rgb(170, 214, 231)"
                                    : "white",
                                "@media (max-width: 900px)": {
                                    width: "12vw",
                                    maxWidth: "100px",
                                },
                                "@media (max-width: 475px)": {
                                    width: "20px",
                                    maxWidth: "30px",
                                },
                            }}
                        >
                            {websiteChoices[index] && (
                                <Box className="selected-close-btn"
                                    style={{
                                        top: "0px",
                                        right: "0px",
                                        padding: "4px",
                                        fontWeight:
                                            typeof questionData.answer.value ===
                                                "object" &&
                                            !Array.isArray(
                                                questionData.answer.value
                                            )
                                                ? "normal"
                                                : "bold",
                                        width: "17.33px",
                                        maxHeight: "20px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveChoice(index);
                                    }}
                                >
                                    X
                                </Box>
                            )}
                            <Button
                                fullWidth
                                disableRipple
                                onClick={() => handleChoiceAssign(index)}
                                sx={{
                                    padding: "4px",
                                    cursor: "pointer",
                                    transition: "box-shadow 0.2s ease-in-out",
                                    textAlign: "center",
                                    lineHeight:
                                        typeof questionData.answer.value ===
                                            "object" &&
                                        !Array.isArray(questionData.answer.value)
                                            ? "1"
                                            : "2.2",
                                    "@media (max-width: 475px)": {
                                        width: "20px",
                                        maxWidth: "30px",
                                    },
                                    color: "black !important",
                                    fontSize:
                                        typeof questionData.answer.value ===
                                            "object" &&
                                        !Array.isArray(questionData.answer.value)
                                            ? "12px"
                                            : "18px",
                                    fontWeight:
                                        typeof questionData.answer.value ===
                                            "object" &&
                                        !Array.isArray(questionData.answer.value)
                                            ? "normal"
                                            : "bold",
                                }}
                            >
                                {websiteChoices[index] ? (
                                    <Box
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Box style={{ fontWeight: "bold" }}>
                                            {websiteChoices[index].header}
                                        </Box>
                                        <Box>{websiteChoices[index].value}</Box>
                                    </Box>
                                ) : (
                                    "\u00A0"
                                )}
                            </Button>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};